
import qs from 'qs';
import CryptoJS from 'crypto-js';

import store from './store';

let RequestHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    'charset': 'UTF-8'
};

export const ROOT_URL = 'https://erpapi.eschool.mn/';
// export const ROOT_URL = 'http://localhost:8001/';

const decrypt = (passphrase, encrypted) => {
    const salt = CryptoJS.enc.Hex.parse("3536373334653339353535373731373635363466");
    const iv = CryptoJS.enc.Hex.parse("36333532333137383339353937383431");

    const key = CryptoJS.PBKDF2(passphrase, salt, { hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999 });
    const decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

const encrypt = (passphrase, plain) => {
    const salt = CryptoJS.enc.Hex.parse("3536373334653339353535373731373635363466");
    const iv = CryptoJS.enc.Hex.parse("36333532333137383339353937383431");

    const key = CryptoJS.PBKDF2(passphrase, salt, { hasher: CryptoJS.algo.SHA512, keySize: 8, iterations: 999 });
    const encrypted = CryptoJS.AES.encrypt(plain, key, { iv: iv });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}


export function fetchRequest(url, method, bodyParams, formData = false) {
    let headerObject = RequestHeaders;

    let requestUrl = ROOT_URL + url;

    const {
        auth: { authToken }
    } = store.getState();

    if (authToken) {
        headerObject['Authorization'] = `Bearer ${authToken?.token}`;
    }

    headerObject['appType'] = `KIOSK`;
    headerObject['NAppType'] = `KIOSK`;
    if (bodyParams) {
        bodyParams = {
            data: encrypt("ESCHOOL_ERP", JSON.stringify(bodyParams))
        }
    }

    let methodObj = 'GET';
    let isPostRequest = false;

    if (method && method.toUpperCase() === 'POST') {
        methodObj = 'POST';
        isPostRequest = true;
    }

    let bodyObj = '{}';

    if (method && method.toUpperCase() === 'GET') {
        requestUrl = `${requestUrl}?${qs.stringify(bodyParams)}`;
    } else {
        if (bodyParams) {
            if (formData) {
                headerObject = {
                    Authorization: `Bearer ${authToken}`,
                };
                bodyObj = bodyParams;
            } else {
                bodyObj = qs.stringify(bodyParams)
            }
        }
    }

    if (url === 'auth/login') {
        delete headerObject.Authorization;
    }

    let requestParameters = null;
    if (isPostRequest) {
        requestParameters = {
            headers: headerObject,
            method: methodObj,
            body: bodyObj
        }
    } else {
        requestParameters = {
            headers: headerObject,
            method: methodObj
        }
    }

    return new Promise((resolve, reject) => {
        fetch(requestUrl, requestParameters)
            .then((response) => {
                if (response.status === 401) {
                    window.location.replace("/logout");
                }
                return response.json()
            })
            .then((responseData) => {
                const data = responseData?.data || null;
                const decrypted = decrypt("ESCHOOL_ERP", data);
                let result = JSON.parse(decrypted);
                // console.log('result',{requestUrl, result});
                result['success'] = responseData?.success || false;
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
    });
}